import React, { useEffect, useState } from 'react';
import ColorInput from 'component/atom/forms/colorInput/ColorInput';
import UploadFile from 'component/atom/forms/uploadInput/UploadInput';
import Select from 'component/atom/forms/select/select/Select';
import Checkbox from 'component/atom/forms/checkbox/Checkbox';
import styles from '../Branding.module.scss';
import Input from 'component/atom/forms/input/input/Input';
import Button from 'component/atom/forms/button/Button';
import login_logo from 'assets/image/login_logo.png';
import logo from 'assets/image/AIDucator-Logo.svg';

function LoginPageContent({
  values,
  setFieldValue,
  tempBGLogin,
  setTempBGLogin,
  bgURL,
  setBgURL,
  branding_BackgroundColor,
  handleUploadChange,
  errors,
  touched,
}) {
  const [containerStyle, setContainerStyle] = useState({
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    margin: values.LoginBackgroundColor ? '0px 0px' : '',
  });

  const fieldsOptions = [
    {
      value: 0,
      label: 'Email Address',
    },
    {
      value: 1,
      label: 'Username',
    },
  ];

  useEffect(() => {
    if (tempBGLogin) {
      const url = URL.createObjectURL(tempBGLogin);
      setBgURL(url);
    } else {
      setBgURL(null);
    }
    return () => {
      if (bgURL) {
        URL.revokeObjectURL(bgURL);
      }
    };
  }, [tempBGLogin]);

  useEffect(() => {
    if (bgURL) {
      setContainerStyle((prevStyle) => ({
        ...prevStyle,
        backgroundImage: `url(${bgURL})`,
        backgroundColor: values.LoginBackgroundColor || '',
      }));
    } else if (values.LoginBackgroundImageContentType === 'image/svg+xml') {
      setContainerStyle((prevStyle) => ({
        ...prevStyle,
        backgroundImage: `url(data:image/svg+xml;base64,${btoa(
          values.LoginBackgroundImage
        )})`,
        backgroundColor: values.LoginBackgroundColor || '',
      }));
    } else {
      setContainerStyle((prevStyle) => ({
        ...prevStyle,
        backgroundImage: `url(data:${values.LoginBackgroundImageContentType};base64,${values.LoginBackgroundImage})`,
        backgroundColor: values.LoginBackgroundColor || '',
      }));
    }
  }, [bgURL, values, tempBGLogin]);

  const handleRemoveTempLogin = () => {
    setFieldValue('LoginBackgroundImage', null);
    setBgURL(null);
    setTempBGLogin(null);
    setFieldValue('LoginBackground_Delete', true);
  };

  return (
    <div className={styles.contentContainer}>
      <div
        className={styles.left}
        style={{
          margin: branding_BackgroundColor ? '0px 0px' : '',
        }}
      >
        <div className={styles.row}>
          <div className={styles.item}>
            <h3 className={styles.rowTitle}>Login Page</h3>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.item}>
            {' '}
            <Select
              label="First Field"
              placeholder="Select First Field"
              name="FirstField"
              value={values.FirstField}
              onChange={(e) => setFieldValue('FirstField', e.target.value)}
              options={fieldsOptions}
            />
          </div>
          <div className={styles.item}>
            {' '}
            <ColorInput
              name="bgColor"
              label={'Background Color'}
              value={values.LoginBackgroundColor}
              onChange={(e) =>
                setFieldValue('LoginBackgroundColor', e.target.value)
              }
              error={errors.LoginBackgroundColor}
              touched={touched.LoginBackgroundColor}
            />
          </div>

          <div className={styles.item}>
            {' '}
            <ColorInput
              name="btnsColor"
              label={'Buttons Color'}
              value={values.LoginButtonColor}
              onChange={(e) =>
                setFieldValue('LoginButtonColor', e.target.value)
              }
              error={errors.LoginButtonColor}
              touched={touched.LoginButtonColor}
            />
          </div>
          <div className={styles.item}>
            {' '}
            <UploadFile
              label={'Background Image'}
              name={'bgImage'}
              inputID="bgImage"
              placeholder="Upload Background Image"
              isImage
              onChange={handleUploadChange}
              image={values.LoginBackgroundImage}
              imageContentType={values.LoginBackgroundImageContentType}
              handleRemoveTempLogin={handleRemoveTempLogin}
            />
          </div>
        </div>

        <div className={`${styles.row} ${styles.SpecialRow}`}>
          <div className={styles.item}>
            {' '}
            <Checkbox
              label={'Add Reset Password'}
              name="addResetPassword"
              ischecked={values.AddResetPassword}
              onChange={() =>
                setFieldValue('AddResetPassword', !values.AddResetPassword)
              }
              rounded
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.item}>
            {' '}
            <Checkbox
              label={'Add Support'}
              name="addSupport"
              ischecked={values.AddSupport}
              onChange={() => setFieldValue('AddSupport', !values.AddSupport)}
              rounded
            />
          </div>
        </div>
      </div>

      <div
        className={styles.right}
        style={{
          ...containerStyle,
          backgroundColor: values.LoginBackgroundColor
            ? values.LoginBackgroundColor
            : '',
        }}
      >
        {' '}
        <h3 className={styles.formTitle}>Login Page</h3>
        {/* <div className={styles.login_icon}> */}{' '}
        {/* <img src={login_logo} />{" "} */}
        <div className={styles['login-logo']}>
          <img src={logo} height={30} />
        </div>
        {/* </div> */}
        <div className={styles.form}>
          <div className={styles.inputs}>
            <Input
              label={`${values.FirstField ? 'Username' : 'Email Address'}`}
              placeholder={`Enter ${
                values.FirstField ? 'Username' : 'Email Address'
              }`}
            />
            <br />
            <Input label="Password" placeholder={`Enter Password`} value={''} />
          </div>

          <div className={styles.formOptions}>
            {values.AddResetPassword && (
              <label className={styles.forgetPassword}>Forgot Password?</label>
            )}
          </div>

          <div className={styles.button}>
            <Button
              label="Login"
              width={'100%'}
              variant={values.LoginButtonColor ? values.LoginButtonColor : ''}
            />
          </div>
          <div className={styles.footer}>
            <label className={styles.terms}>Terms and Conditions</label>
            {values.AddSupport && (
              <label className={styles.support}>Need Support?</label>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPageContent;
